import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CreateQuizResponse } from './createQuiz';

export async function updateQuiz(
   quizid: number,
   quizJson: string,
   { ...common }: CommonRequestOptions
): Promise<CreateQuizResponse> {
   return makeRequest('patch', '/quizzes/update', {
      ...common,
      body: {
         quizid,
         quizJson,
      },
   });
}
